import React from 'react'
import { tokens } from './tokens'
import {
    Arachide,
    BagOnClick,
    Biking,
    BurgerKare,
    CameraPlus,
    Card,
    Catalog,
    CcHandLogo,
    Celery,
    CircleAvatar,
    CircleCrown,
    CircleLock,
    CirclePencil,
    CirclePlus,
    CreditCard,
    Crustacean,
    Currently,
    Delivery,
    Drive,
    Egg,
    Facebook,
    Family,
    FidelityCard,
    FilledLock,
    GameArea,
    Gluten,
    Handicapped,
    HeartFamily,
    Hexagon,
    HexagonBorder,
    HotNews,
    Info,
    Instagram,
    Jobs,
    KingBreakfast,
    Light,
    Lupine,
    Map,
    Milk,
    Mollusc,
    Mustard,
    Nitrate,
    Nut,
    Offers,
    Order,
    PaperNews,
    PreOrder,
    Question,
    Search,
    Sesame,
    SmallSnacks,
    Soy,
    Store,
    Ticket,
    TikTok,
    Twitter,
    Upload
} from 'app/assets/icons'
import {
    AirCond,
    Avatar,
    BabyBurgers,
    Bag,
    BagKingJr as King,
    Beef,
    Birthday,
    Burger,
    ChevaletIcon,
    Chicken,
    CircleBacon,
    CircleBeef,
    CircleChicken,
    CircleColdDrink,
    CircleFish,
    CircleHotDrink,
    CircleKingBox,
    CircleSalad,
    CircleVeggie,
    ClickAndCollect,
    ClickAndCollectDrive,
    ClickAndCollectGo,
    ClickAndCollectOnSite,
    ClickAndParking,
    ColdDrink,
    Crown,
    Deals as KingDeal,
    DeliveryInApp,
    Eye,
    Fish,
    Fries as Snacks,
    HotDrink,
    KingFusion as Delices,
    LittleMenu as Menu,
    Lock,
    Logo,
    Marker,
    MealVoucher,
    Moon,
    OnSite,
    Parking,
    Salad,
    Sauce,
    TableService,
    TakeAway,
    Terrace,
    WaitingOnSite,
    Wifi,
    Wrap
} from 'app-v2/assets/icons'
import type { IconProps } from './types'

export const getIcon = (props: IconProps) => {
    const { code = '', ...otherProps } = props
    switch (code.toUpperCase()) {
        case tokens.account:
            return <Crown {...otherProps} />
        case tokens.airCond:
            return <AirCond {...otherProps} />
        case tokens.arachide:
            return <Arachide {...otherProps} />
        case tokens.avatar:
            return <Avatar {...otherProps} />
        case tokens.bag:
            return <Bag {...otherProps} />
        case tokens.beef:
            return <Beef {...otherProps} />
        case tokens.biking:
            return <Biking {...otherProps} />
        case tokens.birthday:
            return <Birthday {...otherProps} />
        case tokens.blazon:
            return <Hexagon {...otherProps} />
        case tokens.blazonBorder:
            return <HexagonBorder {...otherProps} />
        case tokens.breakfast:
            return <KingBreakfast {...otherProps} />
        case tokens.burgers:
            return <Burger {...otherProps} />
        case tokens.burgerKare:
            return <BurgerKare {...otherProps} />
        case tokens.cameraPlus:
            return <CameraPlus {...otherProps} />
        case tokens.card:
            return <Card {...otherProps} />
        case tokens.catalog:
            return <Catalog {...otherProps} />
        case tokens.ccHand:
            return <BagOnClick {...otherProps} />
        case tokens.ccHandLogo:
            return <CcHandLogo {...otherProps} />
        case tokens.celeri:
            return <Celery {...otherProps} />
        case tokens.chicken:
            return <Chicken {...otherProps} />
        case tokens.childsMenu:
            return <King {...otherProps} />
        case tokens.circleAvatar:
            return <CircleAvatar {...otherProps} />
        case tokens.circleMenuBeef:
        case tokens.circleBeef:
            return <CircleBeef {...otherProps} />
        case tokens.circleMenuChicken:
        case tokens.circleChicken:
            return <CircleChicken {...otherProps} />
        case tokens.circleColdDrink:
            return <CircleColdDrink {...otherProps} />
        case tokens.circleMenuFish:
        case tokens.circleFish:
            return <CircleFish {...otherProps} />
        case tokens.circleKingbox:
            return <CircleKingBox {...otherProps} />
        case tokens.circleHotDrink:
            return <CircleHotDrink {...otherProps} />
        case tokens.circleLock:
            return <CircleLock {...otherProps} />
        case tokens.circlePencil:
            return <CirclePencil {...otherProps} />
        case tokens.circlePlus:
            return <CirclePlus {...otherProps} />
        case tokens.circleSalad:
            return <CircleSalad {...otherProps} />
        case tokens.circleVeggie:
            return <CircleVeggie {...otherProps} />
        case tokens.circleCrown:
            return <CircleCrown {...otherProps} />
        case tokens.clickAndCollect:
            return <ClickAndCollect {...otherProps} />
        case tokens.clickAndCollectGo:
            return <ClickAndCollectGo {...otherProps} />
        case tokens.clickAndCollectDrive:
            return <ClickAndCollectDrive {...otherProps} />
        case tokens.clickAndCollectOnSite:
            return <ClickAndCollectOnSite {...otherProps} />
        case tokens.clickAndParking:
            return <ClickAndParking {...otherProps} />
        case tokens.coldDrinks:
        case tokens.drinks:
        case tokens.drinksEdit:
            return <ColdDrink {...otherProps} />
        case tokens.crab:
            return <Crustacean {...otherProps} />
        case tokens.creditCard:
            return <CreditCard {...otherProps} />
        case tokens.crown:
            return <Crown {...otherProps} />
        case tokens.delivery:
        case tokens.deliveryDeliveroo:
        case tokens.deliveryUbereats:
            return <Delivery {...otherProps} />
        case tokens.deliveryInApp:
            return <DeliveryInApp {...otherProps} />
        case tokens.drive:
            return <Drive {...otherProps} />
        case tokens.egg:
            return <Egg {...otherProps} />
        case tokens.eye:
            return <Eye {...otherProps} />
        case tokens.family:
            return <Family {...otherProps} />
        case tokens.facebook:
            return <Facebook {...otherProps} />
        case tokens.fidelityCard:
            return <FidelityCard {...otherProps} />
        case tokens.filledLock:
            return <FilledLock {...otherProps} />
        case tokens.fish:
            return <Fish {...otherProps} />
        case tokens.freeWifi:
            return <Wifi {...otherProps} />
        case tokens.gluten:
            return <Gluten {...otherProps} />
        case tokens.heartFamily:
            return <HeartFamily {...otherProps} />
        case tokens.hotDrinks:
            return <HotDrink {...otherProps} />
        case tokens.info:
            return <Info {...otherProps} />
        case tokens.instagram:
            return <Instagram {...otherProps} />
        case tokens.jobs:
            return <Jobs {...otherProps} />
        case tokens.kingBreakfast:
            return <KingBreakfast {...otherProps} />
        case tokens.kingDeal:
            return <KingDeal {...otherProps} />
        case tokens.kingdom:
            return <Avatar {...otherProps} />
        case tokens.tableOrder:
            return <ChevaletIcon {...otherProps} />
        case tokens.legal:
            return <PaperNews {...otherProps} />
        case tokens.light:
            return <Light {...otherProps} />
        case tokens.littlePleasures:
            return <KingDeal {...otherProps} />
        case tokens.lock:
            return <Lock {...otherProps} />
        case tokens.logo:
            return <Logo {...otherProps} />
        case tokens.lupin:
            return <Lupine {...otherProps} />
        case tokens.marker:
            return <Marker {...otherProps} />
        case tokens.mealVoucher:
            return <MealVoucher {...otherProps} />
        case tokens.menu:
            return <Menu {...otherProps} />
        case tokens.milk:
            return <Milk {...otherProps} />
        case tokens.mustard:
            return <Mustard {...otherProps} />
        case tokens.new:
            return <HotNews {...otherProps} />
        case tokens.nightOpening:
            return <Moon {...otherProps} />
        case tokens.noBacon:
            return <CircleBacon {...otherProps} />
        case tokens.now:
            return <Currently {...otherProps} />
        case tokens.nut:
            return <Nut {...otherProps} />
        case tokens.offers:
            return <Offers {...otherProps} />
        case tokens.onSite:
            return <OnSite {...otherProps} />
        case tokens.order:
            return <Order {...otherProps} />
        case tokens.orders:
            return <ClickAndCollect {...otherProps} />
        case tokens.parking:
            return <Parking {...otherProps} />
        case tokens.playground:
            return <GameArea {...otherProps} />
        case tokens.preOrder:
            return <PreOrder {...otherProps} />
        case tokens.prm:
            return <Handicapped {...otherProps} />
        case tokens.question:
            return <Question {...otherProps} />
        case tokens.salads:
            return <Salad {...otherProps} />
        case tokens.sauce:
            return <Sauce {...otherProps} />
        case tokens.babyBurgers:
            return <BabyBurgers {...otherProps} />
        case tokens.search:
            return <Search {...otherProps} />
        case tokens.sesame:
            return <Sesame {...otherProps} />
        case tokens.shellfish:
            return <Mollusc {...otherProps} />
        case tokens.smallSnacks:
            return <SmallSnacks {...otherProps} />
        case tokens.snacks:
            return <Snacks {...otherProps} />
        case tokens.soja:
            return <Soy {...otherProps} />
        case tokens.store:
            return <Store {...otherProps} />
        case tokens.stores:
            return <Map {...otherProps} />
        case tokens.sulfite:
            return <Nitrate {...otherProps} />
        case tokens.sweets:
            return <Delices {...otherProps} />
        case tokens.tableService:
            return <TableService {...otherProps} />
        case tokens.terrace:
            return <Terrace {...otherProps} />
        case tokens.takeaway:
            return <TakeAway {...otherProps} />
        case tokens.ticket:
            return <Ticket {...otherProps} />
        case tokens.tiktok:
            return <TikTok {...otherProps} />
        case tokens.twitter:
            return <Twitter {...otherProps} />
        case tokens.upload:
            return <Upload {...otherProps} />
        case tokens.wraps:
            return <Wrap {...otherProps} />
        case tokens.waitingOnSite:
            return <WaitingOnSite {...otherProps} />
        default:
            return null
    }
}
